export default [
    {
        path: "/app/:userDeptRoleId/document",
        components: {
            default: () => import("../views/document/index.vue")
        },
        name: "document"
    },
    {
        path: "/app/:userDeptRoleId/document/detail/:id",
        components: {
            default: () => import("../views/document/index.vue"),
            detail: () => import("../views/document/detail.vue")
        },
        name: "DocumentDetail"
    },
];



// WEBPACK FOOTER //
// ./src/router/document.js